import accounting from 'accounting'

let currency = (v, prefix = '', length = 2) => {
  return accounting.formatMoney(v, prefix, length)
}

let number = (v, length = 2, sperator = ',') => {
  return accounting.formatNumber(v, length, sperator)
}

let unformat = (v) => { // 货币格式变为数字
  return accounting.unformat(v)
}

let tofixed = (v, length = 2) => { // 将数字保留几位小数
  return accounting.toFixed(v, length)
}

export default {
  number,
  currency,
  unformat,
  tofixed
}



// WEBPACK FOOTER //
// ./src/filter/index.js